import React, { useEffect, useState } from "react";

import Modal from "../../Components/Modal/Modal";
import SmallCard from "../../Components/SmallCard/SmallCard";
import Select from "../../Components/Select/Select";
import Input from "../../Components/Input/Input";
import FileInput from "../../Components/FileInput/FileInput";
import { mimeTypes } from '../../constants/constants';

import styles from "./document.modal.styles.module.css"
import pdfIcon from "../../icons/PdfIcon.svg";
import check from "../../images/Check.svg"
import checkEmpty from "../../images/Check_Empty.svg"
import EmptyBlock from "../../Components/EmptyBlock/EmptyBlock";

export default function DocumentModal({ saveDocument, request, documentTypes, uploadedDocument, isOpen, setOpen, setUploadedDocument, setRequest }) {

  const [documentType, setDocumentType] = useState();
  const [participants, setParticipants] = useState()
  const [number, setNumber] = useState();
  const [series, setSeries] = useState();
  const [issuedBy, setIssuedBy] = useState();
  const [date, setDate] = useState(new Date().toLocaleDateString("ru"));

  const uploadDocument = () => {
    const participantIds = participants
      .filter(object => !object.isDisabled)
      .map(({ Id }) => Id);
    saveDocument(request.Id, documentType, uploadedDocument, participantIds).then(x=>window.location.reload())
    
    const newState = request.Documents;
    // newState.push({ FileName: uploadedDocument.Name })
    // setRequest({ ...request, Documents: newState })
  }
  useEffect(() => {
    setParticipants(request?.Participants)
  }, [isOpen]);


  const selectMember = (x) => {
    const newState = participants.map(obj => {
      if (obj.Id === x.Id) {
        return { ...obj, isSelected: !obj.isSelected };
      }
      return obj;
    });

    setParticipants(newState)
  }
  return (
    <Modal
      title="Добавление документа"
      onSave={() => uploadDocument()}
      isOpen={isOpen}
      setOpen={setOpen}
    >
      {uploadedDocument === null &&
        <FileInput
          accept={[mimeTypes.Pdf, mimeTypes.Docx]}
          value={uploadedDocument}
          onChange={(value) => setUploadedDocument(value)}
        />
      }
      {uploadedDocument != null &&
        <React.Fragment>
          <SmallCard
            onRemove={() => setUploadedDocument(null)}
            title={uploadedDocument.name}
            subtitle={`${(uploadedDocument.size / 1024 / 1024).toFixed(1)} мб`}
            avatar={pdfIcon}
            type="default"
          />
          <Select
            value={documentType}
            onChange={(value) => setDocumentType(value)}
            placeholder="Выберите из списка"
            label="Тип документа"
          >
            {documentTypes.map((x) =>
              <option value={x.code}>{x.name}</option>
            )}
          </Select>
          <Input
            value={number}
            mask={Number}
            onChange={(value) => setNumber(value)}
            placeholder=""
            label="Номер документа"
          />
          <Input
            value={series}
            mask={Number}
            onChange={(value) => setSeries(value)}
            placeholder=""
            label="Серия документа"
          />
          <Input
            value={issuedBy}
            onChange={(value) => setIssuedBy(value)}
            placeholder=""
            label="Кем выдан"
          />
          <Input
            label="Дата выдачи"
            value={date}
            mask={Date}
            placeholder='23.09.2023'
            onChange={(value) => setDate(value)}
          />

          <div className={styles.documentMembers}>
            <span className={styles.documentMembersTitle}>
              Выберите заявителей (подписантов) для данного документа
            </span>
            {participants.length == 0 &&
              <EmptyBlock title="Подписанты отсутсвуют"></EmptyBlock>
            }
            {participants.filter(x => x.UlAgent).map((x) =>
              <SmallCard
                key={x.Id}
                type={x.isSelected ? "primary" : "default"}
                onSelect={() => selectMember(x)}
                title={x.UlAgent.name}
                subtitle={x.type}
                avatar={x.isSelected ? check : checkEmpty}
              />
            )}
            {participants.filter(x => x.FlSubject).map((x) =>
              <SmallCard
                key={x.Id}
                type={x.isSelected ? "primary" : "default"}
                onSelect={() => selectMember(x)}
                title={x.FlSubject.name}
                subtitle={x.type}
                avatar={x.isSelected ? check : checkEmpty}
              />
            )}
            {participants.filter(x => x.UlAgentFlSubject).map((x) =>
              <SmallCard
                type={x.isSelected ? "primary" : "default"}
                key={x.Id}
                onSelect={() => selectMember(x)}
                title={x.UlAgentFlSubject.name}
                avatar={x.isSelected ? check : checkEmpty}

              />
            )}
          </div>
        </React.Fragment>
      }
    </Modal>
  )
}